import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';
import { deleteHtmlTagsFromString, parseTextareaAnswer } from '../../../../lib/exercise';
import MathContent from '../../../math-content';

export const Badge = styled.div`
    box-sizing: border-box;
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;

    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    cursor: default;

    ${(props) =>
        props.type === 'error' &&
        css`
            border: 1px solid var(--color-error-default);
            background-color: var(--color-error-default);
            color: var(--color-white);
        `}
    ${(props) =>
        props.type === 'success' &&
        css`
            border: 1px solid var(--color-success-default);
            background-color: var(--color-success-default);
            color: var(--color-white);
        `}
        ${(props) =>
        props.type === 'warning' &&
        css`
            border: 1px solid var(--color-warning-default);
            background-color: var(--color-warning-default);
            color: var(--color-white);
        `};

    ${(props) =>
        props.type === 'missing' &&
        css`
            border: 1px solid var(--gray700);
            background-color: var(--gray700);
            color: var(--color-white);
        `}
`;

export const Container = styled.div`
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    min-height: 32px;
    margin: 4px 0;
    border: 1px solid var(--gray200);
    ${(props) =>
        props.type === 'error' &&
        css`
            border: 1px solid var(--color-error-default);
            background-color: var(--red50);
        `}

    ${(props) =>
        props.type === 'success' &&
        css`
            border: 1px solid var(--color-success-default);
            background-color: var(--green50);
        `}

    ${(props) =>
        props.type === 'warning' &&
        css`
            border: 1px solid var(--color-warning-default);
            background-color: var(--yellow50);
        `}

    ${(props) =>
        props.type === 'missing' &&
        css`
            border: 1px solid var(--gray700);
            background-color: var(--gray50);
        `}

        ${(props) =>
        !props.badgeIndex &&
        css`
            width: 100%;
        `}
`;

export const Answer = styled.div`
    white-space: pre-wrap;
    box-sizing: border-box;
    min-width: 32px;
    color: var(--gray800);
    font-size: 16px;
    letter-spacing: 0;
    line-height: normal;
    padding: 0 8px;
    cursor: default;
`;

const ValidatedTextarea = ({ badgeIndex, value, type, parse = true }) => {
    const answerContent = parse ? value && parseTextareaAnswer(deleteHtmlTagsFromString(value)) : value;

    return (
        <Container type={type} badgeIndex={badgeIndex}>
            {badgeIndex && <Badge type={type}>{badgeIndex}</Badge>}

            <Answer disabled={true}>
                <MathContent>{answerContent}</MathContent>
            </Answer>
        </Container>
    );
};

ValidatedTextarea.propTypes = {
    badgeIndex: PropTypes.string,
    value: PropTypes.string,
    parse: PropTypes.bool,
    type: PropTypes.oneOf(['', 'error', 'success', 'warning', 'missing']),
};

export default ValidatedTextarea;
